<ng-container [formGroup]="editorForm">
  <ca-multi-form-version-selector
    formControlName="editor"
    [forms]="forms"></ca-multi-form-version-selector>
</ng-container>
